/**
 * Geohash decoding utilities.
 * Extracted from tomass-recording.component.ts for shared use.
 */

export interface GeohashBounds {
  minLat: number;
  maxLat: number;
  minLng: number;
  maxLng: number;
}

const BASE32 = '0123456789bcdefghjkmnpqrstuvwxyz';

/**
 * Decode a geohash string into lat/lng bounding box.
 */
export function decodeGeohash(geohash: string): GeohashBounds | null {
  if (!geohash || typeof geohash !== 'string') {
    return null;
  }

  let isEven = true;
  let minLat = -90.0;
  let maxLat = 90.0;
  let minLng = -180.0;
  let maxLng = 180.0;

  for (const char of geohash.toLowerCase()) {
    const index = BASE32.indexOf(char);
    if (index === -1) {
      return null;
    }

    for (let bit = 4; bit >= 0; bit--) {
      const bitValue = (index >> bit) & 1;
      if (isEven) {
        const mid = (minLng + maxLng) / 2;
        if (bitValue === 1) {
          minLng = mid;
        } else {
          maxLng = mid;
        }
      } else {
        const mid = (minLat + maxLat) / 2;
        if (bitValue === 1) {
          minLat = mid;
        } else {
          maxLat = mid;
        }
      }
      isEven = !isEven;
    }
  }

  return { minLat, maxLat, minLng, maxLng };
}

/**
 * Convert a geohash to its center lat/lng coordinates.
 */
export function geohashToLatLng(geohash: string): { lat: number; lng: number } | null {
  const bounds = decodeGeohash(geohash);
  if (!bounds) {
    return null;
  }
  return {
    lat: (bounds.minLat + bounds.maxLat) / 2,
    lng: (bounds.minLng + bounds.maxLng) / 2,
  };
}
